import { DateTime } from 'luxon'

export default {
  data() {
    return {
      searchText: ''
    }
  },

  computed: {
    parsedDocumentsList() {
      return this.$store.getters.documentsList
        .map((documentsListItem) => {
          return {
            ...documentsListItem,
            date: DateTime.fromFormat(documentsListItem.created, 'dd MMM yyyy TT', {
              zone: 'utc'
            })
              .toLocal()
              .toFormat('dd.MM.yyyy HH:mm')
          }
        })
        .sort((documentsListItem1, documentsListItem2) => {
          const name1 = (documentsListItem1.name || '').toUpperCase()
          const name2 = (documentsListItem2.name || '').toUpperCase()

          if (name1 < name2) {
            return -1
          }
          if (name1 > name2) {
            return 1
          }

          //Если названия равны при приведении к большому регистру, то сравним в исходном регистре
          if (documentsListItem1.name < documentsListItem2.name) {
            return -1
          }
          if (documentsListItem1.name > documentsListItem2.name) {
            return 1
          }
          return 0
        })
    },

    list() {
      if (!this.searchText) {
        return this.parsedDocumentsList
      }

      return this.parsedDocumentsList.filter((documentsListItem) => {
        if (typeof documentsListItem.name !== 'string') {
          return false
        }

        return documentsListItem.name.toUpperCase().includes(this.searchText.toUpperCase())
      })
    }
  },

  methods: {
    searchTextChanged(value) {
      if (this.searchTimeout) {
        window.clearTimeout(this.searchTimeout)
        this.searchTimeout = null
      }

      this.searchTimeout = window.setTimeout(() => {
        this.searchText = value
      }, 400)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/documentSearch.js